import {
  NOTE_PREVIEW_BULLET_CLOSE_BRACKETS,
  NOTE_PREVIEW_BULLET_OPEN_BRACKETS,
  NOTE_PREVIEW_BULLET_SEPARATOR,
  NOTE_PREVIEW_SENTENCE_TERMINATOR,
  NOTE_PREVIEW_WHITESPACE,
} from "./note-preview-constant";

export const splitOutsideBrackets = (
  text: string,
  isSeparator: (char: string, next: string | undefined) => boolean
): string[] => {
  const items: string[] = [];
  let depth = 0;
  let current = "";
  const chars = Array.from(text);
  chars.forEach((char, index) => {
    if (NOTE_PREVIEW_BULLET_OPEN_BRACKETS.includes(char)) depth += 1;
    else if (NOTE_PREVIEW_BULLET_CLOSE_BRACKETS.includes(char))
      depth = Math.max(0, depth - 1);
    if (depth === 0 && isSeparator(char, chars[index + 1])) {
      items.push(current);
      current = "";
    } else {
      current += char;
    }
  });
  items.push(current);
  return items.map((item) => item.trim()).filter(Boolean);
};

const isComma = (char: string) => char === NOTE_PREVIEW_BULLET_SEPARATOR;

// A dot ends an item only when followed by whitespace, so "0.02 %" and "10/19/2026." stay intact.
const isSentenceEnd = (char: string, next: string | undefined) =>
  char === NOTE_PREVIEW_SENTENCE_TERMINATOR &&
  (next === undefined || NOTE_PREVIEW_WHITESPACE.test(next));

/** "Last PCP visit: rerere. Last mammogram: rrrr" → one bullet per "Label: value" sentence. */
export const splitIntoSentences = (text: string): string[] =>
  splitOutsideBrackets(text, isSentenceEnd);

export const splitOnCommas = (text: string): string[] =>
  splitOutsideBrackets(text, isComma);
